import { render, staticRenderFns } from "./ClassificacaoFiscalSelect.vue?vue&type=template&id=6a8fb506&"
import script from "./ClassificacaoFiscalSelect.vue?vue&type=script&lang=js&"
export * from "./ClassificacaoFiscalSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports